/*
 * <bundle-tab> — bundle selector cards.
 *
 * Selectable cards are <button role="radio"> (the single product + bundles
 * without their own URL). Clicking one selects it and sets the add-to-cart
 * quantity on the product form (updates an existing quantity input or injects
 * a hidden one). Bundle cards with a URL are plain links and navigate instead.
 * Pair with a Shopify bundle app for true multi-product bundles.
 */
(function () {
  if (typeof customElements === 'undefined' || customElements.get('bundle-tab')) {
    return;
  }

  class BundleTab extends HTMLElement {
    connectedCallback() {
      if (this._inited) return;
      this._inited = true;

      this.cards = Array.prototype.slice.call(
        this.querySelectorAll('.bundle__card[role="radio"]')
      );
      if (!this.cards.length) return;

      var self = this;
      this.cards.forEach(function (card) {
        card.addEventListener('click', function () { self._select(card); });
      });

      var selected = this.querySelector('.bundle__card.is-selected[role="radio"]') || this.cards[0];
      this._mark(selected);
      this._applyQty(selected);
    }

    _mark(card) {
      this.cards.forEach(function (c) {
        var on = c === card;
        c.classList.toggle('is-selected', on);
        c.setAttribute('aria-checked', on ? 'true' : 'false');
      });
    }

    _select(card) {
      this._mark(card);
      this._applyQty(card);
    }

    _form() {
      var scope = this.closest('.product-info') || document;
      return scope.querySelector('form[is="product-form"]') ||
             document.querySelector('form[is="product-form"]');
    }

    _applyQty(card) {
      var qty = parseInt(card && card.dataset.qty, 10);
      if (!qty || qty < 1) qty = 1;

      var form = this._form();
      if (!form) return;

      var input = form.querySelector('input[name="quantity"]');
      if (!input) {
        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        input.setAttribute('data-bundle-quantity', '');
        form.appendChild(input);
      }
      if (String(input.value) !== String(qty)) {
        input.value = qty;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  customElements.define('bundle-tab', BundleTab);
})();
